<template>

	<div class="row lobby-article">

		<div class="col-xs-12" v-show="!article.loading">

			<div class="article-body">
				<div v-html="article.content">
				</div>
			</div>
		</div>
		<div class="col-xs-12 text-center mv40" v-show="article.loading">
			<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
		</div>
	</div>

</template>

<script>

	import Article from "../../../../common/model/article/Article";
	export default {
		props: {
			article: {
				type: Article,
				required: true
			}
		},
		data () {
			return {
				user: this.$store.state.user
			}
		},
		computed: {},
		components: {},
		watch: {},
		methods: {},
		mounted(){
		}
	}

</script>


<style lang="less" rel="stylesheet/less">

	.lobby-article {
		.article-body {

			padding: 20px 20px;
			-webkit-border-radius: 5px;
			-moz-border-radius: 5px;
			border-radius: 5px;

		}
		img {
			max-width: 100%;
		}
	}


</style>




// WEBPACK FOOTER //
// ArticleView.vue?c61b0d44